// FT-193 STEP-17 (REQ-06, REQ-07, REQ-09, CTR-02, CTR-05): словари состояния автопродления, источника списания и
// исхода платежа Т-Банка для BookingCard. Значения приходят от сервера (Booking#periodic_renewal_state,
// #periodic_funding, TinkoffPayment#outcome); подписи — явные ключи локалей, а не собранные из значения:
// незнакомое значение (сервер новее клиента) показывается как есть, а не голым keypath.

export const PERIODIC_RENEWAL_STATE_LABEL_KEYS = Object.freeze({
  active: "bookings.periodic_renewal.state.active",
  awaiting_payment: "bookings.periodic_renewal.state.awaiting_payment",
  blocked_credit_limit: "bookings.periodic_renewal.state.blocked_credit_limit",
  blocked_car_conflict: "bookings.periodic_renewal.state.blocked_car_conflict",
  blocked_currency: "bookings.periodic_renewal.state.blocked_currency",
  stopped_errors: "bookings.periodic_renewal.state.stopped_errors",
});

const PERIODIC_RENEWAL_STATE_COLORS = Object.freeze({
  active: "success",
  awaiting_payment: "info",
  blocked_credit_limit: "warning",
  blocked_car_conflict: "warning",
  blocked_currency: "warning",
  stopped_errors: "error",
});

// Состояния «автопродление остановлено»: в карточке вместо строки со статусом показывается блок-предупреждение
// с причиной и действиями. Остальные состояния (работает, ждём оплату, незнакомое) — обычная строка.
export const PERIODIC_RENEWAL_STOPPED_STATES = Object.freeze([
  "blocked_credit_limit",
  "blocked_car_conflict",
  "blocked_currency",
  "stopped_errors",
]);

// Причина остановки по лимиту: Booking#periodic_block_reason = { code, detail } (контракт FT-193 с api). Тексты — явные
// ключи локалей; код, которого клиент не знает (сервер новее), показывается как credit_limit — самый общий случай.
export const PERIODIC_BLOCK_REASON_KEYS = Object.freeze({
  bank_recurring_disabled: "bookings.periodic_renewal.block_reason.bank_recurring_disabled",
  bank_declined: "bookings.periodic_renewal.block_reason.bank_declined",
  card_unbound: "bookings.periodic_renewal.block_reason.card_unbound",
  receipt_contact_missing: "bookings.periodic_renewal.block_reason.receipt_contact_missing",
  other_terminal: "bookings.periodic_renewal.block_reason.other_terminal",
  no_card: "bookings.periodic_renewal.block_reason.no_card",
  attempts_exhausted: "bookings.periodic_renewal.block_reason.attempts_exhausted",
  credit_limit: "bookings.periodic_renewal.block_reason.credit_limit",
});

export function periodicRenewalStopped(state) {
  return PERIODIC_RENEWAL_STOPPED_STATES.includes(state);
}

export function periodicBlockReasonKey(reason) {
  const code = reason && reason.code;
  return PERIODIC_BLOCK_REASON_KEYS[code] || PERIODIC_BLOCK_REASON_KEYS.credit_limit;
}

// Текст банка (detail) бывает только у bank_declined и уже очищен сервером; пустой или не строка — без хвоста.
export function periodicBlockReasonDetail(reason) {
  if (!reason || reason.code !== "bank_declined") return "";
  return typeof reason.detail === "string" ? reason.detail.trim() : "";
}

export const PERIODIC_FUNDING_LABEL_KEYS = Object.freeze({
  balance: "bookings.periodic_funding_balance",
  balance_and_card: "bookings.periodic_funding_balance_and_card",
});

export const TINKOFF_OUTCOME_LABEL_KEYS = Object.freeze({
  success: "tinkoff.outcomes.success",
  partial_refund: "tinkoff.outcomes.partial_refund",
  refund: "tinkoff.outcomes.refund",
  failed: "tinkoff.outcomes.failed",
  unknown: "tinkoff.outcomes.unknown",
  stale: "tinkoff.outcomes.stale",
});

const TINKOFF_OUTCOME_COLORS = Object.freeze({
  success: "success",
  partial_refund: "warning",
  refund: "warning",
  failed: "error",
  unknown: "grey",
  stale: "orange",
});

export function periodicRenewalStateColor(state) {
  return PERIODIC_RENEWAL_STATE_COLORS[state] || "grey";
}

export function tinkoffOutcomeColor(outcome) {
  return TINKOFF_OUTCOME_COLORS[outcome] || "grey";
}

// Платёж «проведён» для строки панели и для count.completed: оплачен и банк не отказал и не вернул всю сумму.
// Частичный возврат платёж не отменяет (разворачивается только возвращённая часть, D11); платежи до фичи
// приходят без outcome — для них решает paid, как раньше.
export function tinkoffPaymentCompleted(payment) {
  if (!payment || !payment.paid) return false;
  return payment.outcome !== "failed" && payment.outcome !== "refund";
}
